
import { supabase } from '@/integrations/supabase/client';
import { ProcurementQuality } from '@/types/database/procurement-quality';

export const createProcurementQuality = async (data: { procurement_id: string }): Promise<ProcurementQuality> => {
  const { data: quality, error } = await supabase
    .from('procurement_quality')
    .insert([data])
    .select()
    .single();

  if (error) {
    console.error('Error creating procurement quality record:', error);
    throw error;
  }

  return quality as unknown as ProcurementQuality;
};

export const getProcurementQuality = async (procurementId: string): Promise<ProcurementQuality | null> => {
  const { data, error } = await supabase
    .from('procurement_quality')
    .select('*')
    .eq('procurement_id', procurementId)
    .maybeSingle();

  if (error) {
    console.error('Error fetching procurement quality:', error);
    throw error;
  }

  return data as unknown as ProcurementQuality;
};

export const updateProcurementQuality = async (
  procurementId: string,
  updates: Partial<ProcurementQuality>
): Promise<ProcurementQuality> => {
  const { data, error } = await supabase
    .from('procurement_quality')
    .update(updates)
    .eq('procurement_id', procurementId)
    .select()
    .single();

  if (error) {
    console.error('Error updating procurement quality:', error);
    throw error;
  }

  return data as unknown as ProcurementQuality;
};
